import { render, staticRenderFns } from "./NextFocusCourse.vue?vue&type=template&id=51f5f6a0"
import script from "./NextFocusCourse.vue?vue&type=script&lang=js"
export * from "./NextFocusCourse.vue?vue&type=script&lang=js"
import style0 from "./NextFocusCourse.vue?vue&type=style&index=0&id=51f5f6a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports